module.exports = __webpack_public_path__ + "img/tick.5228ea23.svg";